import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { profileDialogAction } from '../redux/slices/profileEditorDialog';
import { Address } from '../models/Addresses';

const useProfileEditorDialog = () => {
    const dispatch = useAppDispatch();
    const profileDialogState = useAppSelector((state) => state.profileDialog);

    const showProfileEditor = (open: boolean, user: any) => {
        dispatch(profileDialogAction.setSelectedUser(user));
        dispatch(
            profileDialogAction.setDialogOpen({
                dialog: 'profile',
                open: open,
            })
        );
    };

    const showAddressesEditor = (open: boolean) => {
        dispatch(
            profileDialogAction.setDialogOpen({
                dialog: 'address',
                open: open,
            })
        );
    };

    const showAdminAddressesEditor = (open: boolean, type: any) => {
        dispatch(
            profileDialogAction.setDialogOpen({
                dialog: 'adminAddress',
                type: type,
                open: open,
            })
        );
    };

    const setSelectedAddress = (data: Address) => {
        dispatch(profileDialogAction.setSelectedAddress(data));
    };

    const setSelectedUserId = (data: number) => {
        dispatch(profileDialogAction.setSelectedUserId(data));
    };

    const setIsAdmin = (isAdmin: boolean) => {
        dispatch(profileDialogAction.setIsAdmin(isAdmin));
    };

    const setAddressDialogClosedWithSuccess = (boolean: boolean) => {
        dispatch(
            profileDialogAction.setAddressDialogClosedWithSuccess(boolean)
        );
    };

    const setProfileDialogClosedWithSuccess = (boolean: boolean) => {
        dispatch(
            profileDialogAction.setProfileDialogClosedWithSuccess(boolean)
        );
    };

    const closeAllDialog = () => {
        showAddressesEditor(false);
        showProfileEditor(false, null);
        showAdminAddressesEditor(false, null);
        setIsAdmin(false);
    };

    return {
        profileDialogState,
        profileEditorStates: profileDialogState.dialog,
        selectedAddressStates: profileDialogState.selectedAddress,
        selectedUserStates: profileDialogState.selectedUser,
        addressDialogClosedWithSuccess:
            profileDialogState.addressDialogClosedWithSuccess,
        profileDialogClosedWithSuccess:
            profileDialogState.profileDialogClosedWithSuccess,
        isAdmin: profileDialogState.isAdmin,
        setIsAdmin,
        showProfileEditor,
        showAddressesEditor,
        showAdminAddressesEditor,
        closeAllDialog,
        setSelectedAddress,
        setAddressDialogClosedWithSuccess,
        setProfileDialogClosedWithSuccess,
        setSelectedUserId,
    };
};

export default useProfileEditorDialog;
